export default __webpack_public_path__ + "static/media/downloadIcon.62dd0641.svg";